module.exports = __webpack_public_path__ + "static/img/m_name.fa89945.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/lxx/m_name.png
// module id = 4cli
// module chunks = 7